const en = {
    'name' :  '성명'
}

export default en 